export default "__VITE_ASSET__DtUEeBG4__"